import { Component, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Yii } from "libraries/interfaces/Yii";
import { IDescriptionLabels } from "libraries/module/formbuilder/fields/form-field/components/field-description/field-description.component";
import { FIELD_DESCRIPTION_LABELS } from "app_sasha/shared/config/booking-wording";
import { ConfigFieldBuilderService } from "../config-field-builder.service";
import { IFieldSpecs } from "libraries/module/formbuilder/fields/interfaces/field-specs";
import {TRAVELLER_ARRAY_FIELDS} from "../config";
import { ESashaPermissions } from "libraries/enums/e-sasha-permissions";
import {
    ApiMembershipCard
} from "../../../../../libraries/service/resources/booking/interfaces/ApiSearchParameters";
import {HelperService} from "../../../services/helper.service";
import {BookingService} from "../../../../../libraries/service/booking/booking.service";
import {IMultiselectOptions} from "../../../../../libraries/module/formbuilder/fields/multiselect/multiselect.model";

interface IFieldConfig {
    [name: string]: IFieldSpecs;
}

@Component({
    selector: 'traveller-fieldset',
    template: `
        <div class="sep-top">
            <collapsible [title]="travellerSearchTitle" [open]="open">
                <div class="sep-top">
                    <chips [fieldConfig]="formFields.person" [toUpper]="chipsToUpper">
                        <field-description [description]="fieldDescriptionLabels.person"></field-description>
                    </chips>
                </div>
                <div class="sep-top" *permissionIf="sashaPermissions.SASHA_BOOKING_SEARCH_PERSON_NOMEMBERSHIP_SHOW">
                    <multiselect
                            [fieldConfig]="formFields.hasMembershipCard"
                            [options]="membershipOptions" [maxSelection]="1"></multiselect>
                </div>
            </collapsible>
        </div>
    `
})
export class TravellerFieldsetComponent implements OnInit {
    @Input()
    public form: FormGroup;

    @Input()
    public open: boolean = true;

    @Input()
    public chipsToUpper: boolean;

    public readonly travellerSearchTitle = Yii.t('wui-sasha-js', 'Personnes');

    public formFields: IFieldConfig;
    public fieldDescriptionLabels: { [key: string]: IDescriptionLabels } = FIELD_DESCRIPTION_LABELS;
    public sashaPermissions: typeof ESashaPermissions = ESashaPermissions;
    public membershipOptions: IMultiselectOptions[];

    constructor(
        private configFieldBuilderService: ConfigFieldBuilderService,
        private readonly helperService: HelperService,
        private readonly bookingService: BookingService,
    ) { }

    public ngOnInit(): void {
        this.formFields = {
            ...this.configFieldBuilderService.buildFieldConfigArray(this.form, TRAVELLER_ARRAY_FIELDS)
        };

        this.membershipOptions = this.helperService.getMultiselectOptions(
            this.bookingService.membershipLabels,
            Object.values(ApiMembershipCard),
            false
        );
    }
}
